export const isEmpty = (val: any) => {
    return val == null || val.length === 0;
};
